import React, { useEffect, useContext } from 'react';
import { StateContext } from '../../contexts/StateContext';

const VideoComponent = ({ videoContent, videoSrc, productHeading }) => {

    const { setPageHeader } = useContext(StateContext);
    const { toggleVideoShow } = useContext(StateContext);
    setPageHeader(videoContent?.name);

    useEffect(() => {
        return () => {
            setPageHeader(productHeading);
        }
    },[]) 

    
    return (
        <div className="video-overlay-component" data-testid="video-overlay-component">
            <button className="close-button" onClick={() => toggleVideoShow(false)}>
                X
            </button>
            <video width={'100%'} controls={true}>
                <source src={videoSrc} type="video/mp4" />
            </video>
        </div>
    );
};

export default VideoComponent;
